import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Low-level skeleton placeholder block with a shimmer animation.
 * Compose several of these to mirror the shape of the content being loaded.
 * Respects `prefers-reduced-motion` (shimmer disabled, static tint shown).
 */
@Component({
  selector: 'inexp-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'presentation',
    'aria-hidden': 'true',
    '[style.width]': 'width()',
    '[style.height]': 'height()',
    '[style.border-radius]': 'radius()',
  },
})
export class SkeletonComponent {
  /** Any CSS length, e.g. '100%', '12rem', '240px'. */
  readonly width = input<string>('100%');
  readonly height = input<string>('1rem');
  /** Border radius; pass '50%' for a circle (avatar). */
  readonly radius = input<string>('4px');
}
